export default __webpack_public_path__ + "static/media/buy.d84fd346.png";